<template>
  <div class="home-ranking-box">
    <div class="title">
      {{ $t("home.risefall") }}
    </div>
    <div>
      <van-row>
        <van-col :span="10">
          <div class="table-head">{{ $t("home.name") }}</div>
        </van-col>
        <van-col :span="9">
          <div class="table-head">{{ $t("home.price") }}</div>
        </van-col>
        <van-col :span="5">
          <div class="table-head txt-right">{{ $t("home.risefall") }}</div>
        </van-col>
      </van-row>
      <div v-if="safeData && safeData.length > 0">
      <van-row class="table-data-row" v-for="(item,index) in safeData" :key="index" @click="toPage(item)">
        <van-col :span="10">
          <div class="table-name">
            <div class="icon">
              <img :src="item.logo" />
            </div>
            <div class="name">{{ item.title.split('/')[0] }}<span>/{{ item.title.split('/')[1] }}</span></div>
          </div>
        </van-col>
        <van-col :span="9">
          <div class="table-price">{{ item.close }}</div>
        </van-col>
        <van-col :span="5">
          <div class="table-rise-fall" :class="item.change.indexOf('+') != -1 ? 'rise':'fall'">{{ item.change }}%</div>
        </van-col>
      </van-row>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HomeRanking",
  props: ['datalst'],
  computed:{
    safeData(){
      return this.datalst || []
    }
  },
  methods:{
    toPage(item){
      this.$router.push(
        {
          name: "options",
          query: {
            currentSymbol: item.symbol,
            name:item.title,
          },
        },
        () => {}
      );
    },
  }
};
</script>

<style>
</style>
